export default [
  { label: 'IndividualCombinedScoresId', key: 'individualCombinedScoresId' },
  { label: 'ExceptionType', key: 'exceptionType' },
  { label: 'Description', key: 'description' },
  { label: 'Comment', key: 'comment' },
  { label: 'EventName', key: 'eventName' },
  { label: 'Team', key: 'team' },
  { label: 'Bowler', key: 'bowler' },
  { label: 'StartDate', key: 'startDate' },
  { label: 'AccountedFor', key: 'accountedFor' },
  { label: 'AccountedForDate', key: 'accountedForDate' },
  { label: 'IsIneligible', key: 'isIneligible' },
  { label: 'IneligibilityConfirmed', key: 'ineligibilityConfirmed' },
  { label: 'IgnoreEligibilityException', key: 'ignoreEligibilityException' },
  { label: 'USBCSchoolId', key: 'uSBCSchoolId' },
  { label: 'DivisionMale', key: 'divisionMale' },
  { label: 'BowlerId', key: 'bowlerId' },
  { label: 'IsBakerOnly', key: 'iSBakerOnly' }
]


// WEBPACK FOOTER //
// ./src/components/pages/Report/constants/rankingExceptionsHeaders.js